module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent",
    style: (_vm.applied_styles.assessmentContainer),
    attrs: {
      "data-name": "assessment-wrapper"
    }
  }, [_c('mu-popover', {
    ref: "popover",
    attrs: {
      "open": _vm.showAssessment,
      "trigger": _vm.popoverAnchor,
      "popoverClass": "assessmentPopover"
    }
  }, [_c('iframe', {
    ref: "container",
    style: (_vm.applied_styles.assessmentFrame),
    attrs: {
      "src": _vm.taskUrl,
      "allowfullscreen": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40ddb954!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bz/assess-container/component.vue
// module id = 980
// module chunks = 2